/**
 * Class to select organization.
 */

Greenmile.DispatcherSelectOrganizationContainer = function (selector) {

    var userSelectOrganizationsContainer = document.querySelector(selector);
    var organizationListContainer = new Greenmile.DispatcherSelectOrganizationList('dispatcherOrganization');

    const renderErrorMessage = () => {
        const errorMessage = document.createElement('p');
        errorMessage.className = 'organizationMessageError';
        errorMessage.innerHTML = Monet.I18n.getResourcesByKey('Greenmile.UserSelectOrganization.errorMessage');
        var element = document.getElementById("listOrganizationContainer");
        element.appendChild(errorMessage);
    }

    const renderSaveButton = () => {
        var sendButton = new Monet.UI.Fields.Button();
        sendButton.setValue(Monet.I18n.getResourcesByKey('Greenmile.UserSelectOrganization.save'));

        sendButton.addEventClickListener(function () {
            const errorMessageContainer = document.querySelector('.organizationMessageError');

            if (organizationListContainer.getValue().length === 0) {
                if (errorMessageContainer) return;
                renderErrorMessage();
            }
            else {
                sendButton.toggleLoadingInBtn();

                errorMessageContainer && errorMessageContainer.remove()

                var ajax = new Monet.Ajax();
                ajax.method = 'post';
                ajax.url = 'UserOrganization/ChangeLoggedUserAllowedOrganizanizations';
                ajax.data = organizationListContainer.getValue();
                ajax.success = function () {
                    location.reload();
                };
                ajax.error = function (xhr) {
                    sendButton.toggleLoadingInBtn();
                    Monet.Configurations.errorNotification(null, xhr);
                };
                ajax.send();
            }
        });

        return sendButton.render();
    };

    this.setListOrganizations = function (listOrganizations) {
        organizationListContainer.setData(listOrganizations);
        return this;
    };


    this.render = function () {

        var container = document.createElement('div');
        var fragment = document.createDocumentFragment();

        container.id = 'listOrganizationContainer';
        container.appendChild(organizationListContainer.render());
        container.appendChild(renderSaveButton());
        fragment.appendChild(container);

        userSelectOrganizationsContainer.appendChild(fragment);

    };

};